import { FormikHelpers, useFormik } from 'formik';

import { FORM_INITIAL_VALUES, FormFieldType, VALIDATION_SCHEMA } from '../form/keys';

interface UseCryptoPayoutFormProps {
  onSubmit: (values: Record<FormFieldType, any>, formikHelpers: FormikHelpers<Record<FormFieldType, any>>) => Promise<void>;
}

export const useCryptoPayoutForm = ({ onSubmit }: UseCryptoPayoutFormProps) => {
  return useFormik({
    initialValues: FORM_INITIAL_VALUES,
    validationSchema: VALIDATION_SCHEMA,
    validateOnChange: false,
    validateOnBlur: true,
    onSubmit,
  });
};
